import React, { FunctionComponent } from 'react';
import { ILabel } from '../../../models/common/label.model';
import { ProductDetailPage } from '../../../../../generated/graphql';
import { IProductService } from '../../../services/product/product-service';
import { IBasketService } from '../../../services/basket/basket-service';
import { AlternativeProductsItem } from './alternative-products-item/alternative-products-item-component';
import styles from './alternative-products-component.module.scss';
import { CustomScrollbar } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../helpers/html.utils';

type AlternativeProductsProps = {
  labels?: ILabel[];
  mainProductStockCode: string;
  products: ProductDetailPage[];
  incVat?: boolean;
  productService?: IProductService;
  basketService?: IBasketService;
  className?: string;
};

export const AlternativeProducts: FunctionComponent<AlternativeProductsProps> = (props: AlternativeProductsProps) => {
  return (
    <div className={`${styles.container} ${props.className ?? ''}`}>
      <span className={styles['alternative-product-title']}>{getLabel(props.labels, 'alternative_product')}</span>
      <CustomScrollbar>
        <div className={styles['products-container']}>
          {props.products.slice(0, 4).map((product) => (
            <AlternativeProductsItem
              labels={props.labels}
              mainProductStockCode={props.mainProductStockCode}
              product={product}
              incVat={props.incVat}
              productService={props.productService}
              basketService={props.basketService}
            />
          ))}
        </div>
      </CustomScrollbar>
    </div>
  );
};
